import { jwtDecode } from "jwt-decode"
import type { JwtPayload } from "jwt-decode"

export function isTokenExpired(idToken: string): boolean {
	try {
		const decodedToken = jwtDecode<JwtPayload>(idToken)
		// add offset of 5 minute to refresh soon expiring token
		return decodedToken.exp ? Date.now() + 5 * 60 * 1000 > decodedToken.exp * 1000 : true
	} catch {
		return true
	}
}
